const host = location.origin;

export default {
  featureFlags: {},
  drawer: null,
  color: 'warning',
  UiTheme: false,
  colorHexLight: undefined,
  colorHexDark: undefined,
  image: './img/transparent.png',
  load: 0,
  loading: false,
  map3DBuild: true,
  snackbar: {
    model: false,
    message: 'This is a snack, yum',
    color: 'success',
    link: undefined,
  },
  refreshToolbar: 0,
  miniVariant: false,
  baseURL: `${host}/api/v1`,
  docsDomain: 'https://docs.niotix.io',
  docsBaseURL: 'https://docs.niotix.io',
  releaseNotesURL: 'https://docs.niotix.io/changelog/',
  systemStatus: 'https://status.digimondo.io/',
  language: 'de',
  mapStyle: 1,
  inpOutlined: true,
  inpFilled: false,
  dtwins: {},
  dtwinStateConfigCopy: null,
  // session-persisted filters for different pages/lists
  // once the page is re-visited, the filters are restored until a full page reload
  // (e.g. orderby, pageidx, filter, search, ...)
  pageFilters: {},
  packageVersion: process.env.PACKAGE_VERSION || '0.0.0',
  announcements: [],
  bannerHeight: 0,
  fireflyUrl:
    process.env.VUE_APP_ENV === 'production-saas' ? 'https://fireflyiot.com' : 'https://stage.fireflyiot.com/',
  refreshGMMinutes: 0,
  rowsPerPage: 20,
  tablePage: 1,
  openedTreeview: [],
  useAltFonts: false,
  n2Accounts: {
    lastFetched: null,
    accounts: [],
    selectedIds: [],
  },
  n1Accounts: {
    lastFetched: null,
    accounts: [],
    selectedIds: [],
  },
  feedbackEmail: '',
};
